const messages = {
    "system": {
        role: 'system',
        content: ''
    },
    "user": {
        role: 'user',
        content: ''
    },
    "assistant": {
        role: 'assistant',
        content: ''
    }
}

export default messages